<template>
    <v-dialog v-model="dialog" :width="width" :persistent="persistent">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close(false)">{{ cancelText }}</v-btn>
          <v-btn :color="color" text @click="close(true)">{{ confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    data() {
      return {
        dialog: false,
        message: '',
        title: '',
        resolve: null,
        width: 400,
        color: 'primary',
        confirmText: 'OK',
        cancelText: 'Cancel',
        persistent: false,
      };
    },
    methods: {
      open(message, title, options = {}) {
        this.message = message;
        this.title = title;
        this.width = options.width || 400;
        this.color = options.color || 'primary';
        this.confirmText = options.confirmText || 'OK';
        this.cancelText = options.cancelText || 'Cancel';
        this.persistent = options.persistent || false;
  
        this.dialog = true;
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      close(result) {
        this.dialog = false;
        this.resolve(result);
      },
    },
  };
  </script>
  